<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'Tandika',

  data() {
    return {

    };
  },

  mounted() { },

  methods: {},
};
</script>

<style lang="scss" scoped></style>